import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { noop } from 'lodash'

import { AuthorisedUser, Collateral, CollateralPrice, EntityType, Product } from 'api'

import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { createProductGetterSelector } from 'selectors/productSelectors'

import { CollateralDialogComponent, ReadonlyFields } from './CollateralDialogComponent'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { CollateralDialogFields } from './collateralDialogUtils'

export interface CollateralDialogViewProps {
  // Own Props
  collateralEntityId: string
  collateralPriceEntityId: string
  onClose?: () => unknown

  // State Props
  getCollateral: (collateralId: string) => Collateral | null
  getCollateralPrice: (collateralPriceId: string) => CollateralPrice | null
  getProduct: (productSectorId: string) => Product | null
  authorisedUser: AuthorisedUser
}

const mapStateToProps = createStructuredSelector({
  getCollateral: createEntityGetterSelector(EntityType.COLLATERAL),
  getCollateralPrice: createEntityGetterSelector(EntityType.COLLATERAL_PRICE),
  getProduct: createProductGetterSelector,
  authorisedUser: createAuthorisedUserSelector()
})

const CollateralDialogViewContainer: React.FC<CollateralDialogViewProps> = props => {
  const {
    getProduct,
    getCollateral,
    getCollateralPrice,
    collateralEntityId,
    collateralPriceEntityId,
    onClose = noop,
    authorisedUser
  } = props

  const collateral = getCollateral(collateralEntityId)
  const collateralPrice = getCollateralPrice(collateralPriceEntityId)

  if (!collateral || !collateralPrice) {
    return null
  }

  const product = getProduct(collateral.productSectorId)

  const readOnly = Object.values(CollateralDialogFields).reduce<ReadonlyFields>(
    (a, fieldName) => ({ ...a, [fieldName]: true }),
    {} as ReadonlyFields
  )

  return (
    <CollateralDialogComponent
      title={collateral.name}
      readOnly={readOnly}
      originalCollateral={null}
      collateral={collateral}
      collateralPrice={collateralPrice}
      collateralPriceValidationIssues={[]}
      validationIssues={[]}
      product={product}
      onClose={() => onClose()}
      onSave={noop}
      onUpdateCollateral={noop}
      onUpdateCollateralPrice={noop}
      userPreference={authorisedUser.userPreference}
    />
  )
}

export const CollateralDialogView = connect(mapStateToProps)(CollateralDialogViewContainer)
